import {
    EuiButton,
    EuiListGroup,
    EuiLoadingSpinner,
    EuiModal,
    EuiModalBody,
    EuiModalFooter,
    EuiModalHeader,
    EuiModalHeaderTitle,
} from "@elastic/eui";
import React from "react";

interface LatestKindsModalProps {
    closeModal: () => void;
    items: {
        name: string;
        last_modified: string;
        href: string;
    }[];
    isLoading: boolean;
    isError: boolean;
}

export const LatestKindsModal = ({ closeModal, items, isLoading, isError }: LatestKindsModalProps) => {
    const formattedItems = items.map((item) => ({
        label: (
            <>
                <p>
                    <strong>{item.name}</strong>
                </p>
                <p>{item.last_modified}</p>
            </>
        ),
        href: item.href,
    }));

    return (
        <EuiModal onClose={closeModal}>
            <EuiModalHeader>
                <EuiModalHeaderTitle>Latest Modified Product Kinds</EuiModalHeaderTitle>
            </EuiModalHeader>

            <EuiModalBody>
                {isLoading ? (
                    <EuiLoadingSpinner />
                ) : isError ? (
                    <p>Error loading items</p>
                ) : (
                    <EuiListGroup listItems={formattedItems} color="text"></EuiListGroup>
                )}
            </EuiModalBody>

            <EuiModalFooter>
                <EuiButton onClick={closeModal} fill>
                    Close
                </EuiButton>
            </EuiModalFooter>
        </EuiModal>
    );
};
